import React from 'react'
import PageSection from '../../components/PageSection'
import CooperationCases from '../../components/CooperationCases'
import EmployeeDining from '@/components/EmployeeDining'
import ServiceCard from '@/components/ServiceCard'
import Solution from '@/components/Solution'
import TabContent from '@/components/TabContent'
import ContactBar from '@/components/ContactBar'
import { useTranslation } from '@sailor/i18n-web'
import { picUrl } from '@/common/utils/consts'

const HomePage: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div >
      <PageSection title={t('ent_o_hero_title')} subtitle={t('ent_o_hero_subtitle')}  backgroundImage={picUrl.titleHeader}/>
      <EmployeeDining />
      <ServiceCard />
      <Solution />
      <TabContent/>
      <CooperationCases />
      <ContactBar />
    </div>
  )
}

export default HomePage